var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('p',{staticClass:"gaizhangh"},[_vm._v("该账号非签署合同的账号，请重新确认")]),_c('div',{staticClass:"queding",on:{"click":_vm.wancheng}},[_vm._v("确定")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gantan"},[_c('img',{staticStyle:{"width":"74px"},attrs:{"src":require("../../../assets/images/rightzhbf.png"),"alt":""}})])
}]

export { render, staticRenderFns }